/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Upload_Category_HintInputs */

const cs_documents_upload_category_hint = /** @type {(inputs: Documents_Upload_Category_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platí pro soubory, které nahrajete — úložný štítek, ne filtr složek.`)
};

const en_documents_upload_category_hint = /** @type {(inputs: Documents_Upload_Category_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applied to files you upload next — storage label, not a folder filter.`)
};

/**
* | output |
* | --- |
* | "Applied to files you upload next — storage label, not a folder filter." |
*
* @param {Documents_Upload_Category_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_upload_category_hint = /** @type {((inputs?: Documents_Upload_Category_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Upload_Category_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_upload_category_hint(inputs)
	return cs_documents_upload_category_hint(inputs)
});